import React from 'react';
import Icon from '../Icon/Icon';
import styles from './FilterChipsBar.module.css';

export interface FilterChipEntry {
  filterKey: string;
  value: string;
  label: string;
  icon?: string;
  iconColor?: string;
  color?: string;
  onRemove: (value: string) => void;
}

interface FilterChipsBarProps {
  chips: FilterChipEntry[];
  compact?: boolean;
}

const FilterChipsBar: React.FC<FilterChipsBarProps> = ({ chips, compact = false }) => {
  if (chips.length === 0) return null;

  return (
    <div className={[styles.bar, compact ? styles.compact : ''].filter(Boolean).join(' ')}>
      {chips.map((chip) => (
        <span key={`${chip.filterKey}-${chip.value}`} className={styles.chip}>
          {chip.icon && <Icon name={chip.icon} size={14} color={chip.iconColor} filled />}
          {chip.color && (
            <span
              className={styles.colorDot}
              style={{ backgroundColor: chip.color }}
            />
          )}
          {chip.label}
          <button
            type="button"
            className={styles.chipRemove}
            onClick={() => chip.onRemove(chip.value)}
            aria-label={`Remover ${chip.label}`}
          >
            <Icon name="close" size={8} />
          </button>
        </span>
      ))}
    </div>
  );
};

export default FilterChipsBar;
